import * as SlideBottomStyles from './components/SlideBottom.css';

const defaultTheme = {
	SlideBottomStyles
};

export default defaultTheme;
